<script lang="ts">
  import PixelIcon, { type PixelIconName } from './PixelIcon.svelte';

  interface Props {
    icon: PixelIconName;
    title: string;
    subtitle: string;
    tone?: 'cyan' | 'mag' | 'yel' | 'grn' | 'blu';
    disabled?: boolean;
    /** The screen's primary action, highlighted per the mockup. */
    featured?: boolean;
    onclick?: () => void;
  }

  let {
    icon,
    title,
    subtitle,
    tone = 'cyan',
    disabled = false,
    featured = false,
    onclick,
  }: Props = $props();
</script>

<button
  type="button"
  class="mb mb--{tone}"
  class:mb--featured={featured}
  {disabled}
  onclick={() => !disabled && onclick?.()}
>
  <span class="ic"><PixelIcon name={icon} size={52} /></span>
  <span class="mb__copy"><span class="t1">{title}</span><span class="t2">{subtitle}</span></span>
  <PixelIcon name="play" size={24} />
</button>
